import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { DialogComponent, DialogModule } from '@syncfusion/ej2-angular-popups';
import { ExportInterfaceFieldAssignmentTemplateDTO } from 'src/app/base/models/models.swagger.generated';
import { TranslateModule } from '@ngx-translate/core';
import { FieldAssignmentTemplatesOverviewComponent } from '../../../../field-assignment-templates-overview/field-assignment-templates-overview.component';


@Component({
    selector: 'app-file-fields-load-from-template-dialog',
    templateUrl: './file-fields-load-from-template-dialog.component.html',
    styleUrls: ['./file-fields-load-from-template-dialog.component.scss'],
    imports: [DialogModule, FieldAssignmentTemplatesOverviewComponent, TranslateModule]
})
export class FileFieldsLoadFromTemplateDialogComponent {
  @Output()
  public loadFromTemplate: EventEmitter<ExportInterfaceFieldAssignmentTemplateDTO> = new EventEmitter<ExportInterfaceFieldAssignmentTemplateDTO>()

  @ViewChild("loadTemplateDialog")
  public dialog: DialogComponent;
  public selectedTemplate: ExportInterfaceFieldAssignmentTemplateDTO;
  public showOverview = false;

  constructor() { }

  public show() {
    this.showOverview = true;
    this.dialog.show();
  }

  public onCancel() {
    this.selectedTemplate = null;
    this.dialog.hide();
    this.showOverview = false;
  }

  public onTemplateSelected(selectedTemplate: ExportInterfaceFieldAssignmentTemplateDTO) {
    this.selectedTemplate = selectedTemplate;
  }

  public onTemplateSelectedAndClose(selectedTemplate: ExportInterfaceFieldAssignmentTemplateDTO) {
    this.selectedTemplate = selectedTemplate;
    this.onOk();
  }

  public onOpen(args: any): void {
    //Preventing the default dialog focus
    args.preventFocus = true;
  }

  public onOk() {
    if (this.selectedTemplate) {
      this.loadFromTemplate.emit(this.selectedTemplate);
    }
    this.selectedTemplate = null;
    this.dialog.hide();
    this.showOverview = false;
  }
}
